import React, { useEffect, useRef, useState } from "react";
import { Button, Icon } from "../../Elements";
import Debounce from "../../Elements/Textboxs/Debounce";

const Voice: React.FC<FileInterface> = ({
    fileAddress,
    className,
    isLoading
}) => {
    const audioElement = useRef<HTMLAudioElement>(null)
    const [isPlay, setIsPlay] = useState<boolean>(false);
    const [time, setTime] = useState<{ duration: number, currentTime: number }>({ currentTime: 0, duration: 0 });
    function updateTrackTime(track: React.SyntheticEvent<HTMLAudioElement, Event>) {
        var currTime = Math.floor(track.currentTarget.currentTime);
        var duration = Math.floor(track.currentTarget.duration);


        if (isNaN(duration) || isNaN(currTime)) {
            setTime({ currentTime: 0, duration: 0 });
        }
        else {
            setTime({ currentTime: currTime, duration: duration });
        }
    }

    const goToTimeOfAudio = (currentTime: number) => {
        if (audioElement.current) {
            setIsPlay(false)
            audioElement.current?.pause()
            setTime({ ...time, currentTime: currentTime })
            audioElement.current!.currentTime = currentTime

            Debounce({
                func: () => {
                    setIsPlay(true)
                },
                timeout: 200
            })

        }
    }
    useEffect(() => {
        if (isPlay)
            audioElement.current?.play()
        else
            audioElement.current?.pause()
    }, [isPlay])


    return <>
        <audio src={fileAddress} ref={audioElement} className="hidden" onTimeUpdate={updateTrackTime} />

        <div className={`${className || ''}  px-2 py-1 rounded-xl relative `}>
            <div className="w-full flex justify-center items-center gap-2 h-7">
                <input type="range" className="accent-primaryLight w-[90%] h-1" style={{ direction: 'ltr' }} value={time.currentTime} max={time.duration} onChange={(e) => {
                    e.preventDefault()
                    const currentTime = parseInt(e.target.value);
                    goToTimeOfAudio(currentTime)
                }} />
                <Icon disabled={isLoading} onClick={() => setIsPlay(!isPlay)} icon={`${isPlay ? 'rayteb-pause' : 'rayteb-play'}`}
                    className={`text-primary text-3xl ${isPlay ? '' : 'pl-[2px] pt-[2px]'}`} />
            </div>
        </div>
    </>
}

export default Voice;